import { render, staticRenderFns } from "./ManutenzioneAnagrafiche.vue?vue&type=template&id=e1b56bde&scoped=true&"
import script from "./ManutenzioneAnagrafiche.vue?vue&type=script&lang=js&"
export * from "./ManutenzioneAnagrafiche.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1b56bde",
  null
  
)

export default component.exports